import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-close",
  "use": "menu-close-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 17\" id=\"menu-close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 7.086L15.715.37a1 1 0 1 1 1.415 1.415L10.414 8.5l6.716 6.715a1 1 0 0 1 .002 1.417.995.995 0 0 1-1.417-.002L9 9.914 2.285 16.63a.999.999 0 0 1-1.417.002.995.995 0 0 1 .002-1.417L7.586 8.5.87 1.785A1 1 0 0 1 1.193.149.995.995 0 0 1 2.285.37L9 7.086z\" fill=\"#5E5E5E\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu-close.svg
// module id = 446
// module chunks = 0